import HeroSection from "./components/HeroSection";
import FeaturedArticles from "./components/FeaturedArticles";
import CategoryGrid from "./components/CategoryGrid";
import LatestArticles from "./components/LatestArticles";
import FAQSection from "./components/FAQSection";
import HomeSEO from "./components/HomeSEO";

export default function Home() {
  return (
    <>
      <HomeSEO />
      <HeroSection />
      <FeaturedArticles />
      <CategoryGrid />
      <LatestArticles />
      <FAQSection />
    </>
  );
}